<div class="grid-container">
  <dx-data-grid
    [dataSource]="sfAccounts$ | async"
    [columns]="columnsGroups"
    keyExpr="accountId"
    [showBorders]="true"
    [filterRow]="{
      visible: true
    }"
    [selectedRowKeys]="selectedGroups"
    (onExporting)="onExporting($event)"
    (onToolbarPreparing)="onToolbarPreparing($event)"
  >
    <dxo-export [enabled]="exportOptions?.enabled ?? false" [formats]="['xlsx']" [allowExportSelectedData]="true"></dxo-export>
    <dxo-selection [allowSelectAll]="true" mode="multiple"></dxo-selection>
    <dxo-scrolling mode="standard"></dxo-scrolling>
    <dxo-pager displayMode="compact" [showPageSizeSelector]="false" [showInfo]="true"></dxo-pager>
    <dxo-paging [pageSize]="pageSize"></dxo-paging>
  </dx-data-grid>
</div>
